import { registerPlugin } from '@capacitor/core';

type SetCountOptions = {
  count: number;
};

type ReferralBadgePlugin = {
  setCount(options: SetCountOptions): Promise<void>;
  clear(): Promise<void>;
};

export const ReferralBadge = registerPlugin<ReferralBadgePlugin>('ReferralBadge');
